
import { WorldCountry } from '../types';

export const eastAsiaData: WorldCountry[] = [
  {
    code: 'CN',
    name: 'China',
    slug: 'china',
    population: 1439323776,
    topCities: [
      { name: 'Shanghai', slug: 'shanghai', population: 27058000 },
      { name: 'Beijing', slug: 'beijing', population: 21542000 },
      { name: 'Chongqing', slug: 'chongqing', population: 15872000 },
      { name: 'Tianjin', slug: 'tianjin', population: 13866000 },
      { name: 'Guangzhou', slug: 'guangzhou', population: 13501000 },
      { name: 'Shenzhen', slug: 'shenzhen', population: 12594000 },
      { name: 'Wuhan', slug: 'wuhan', population: 11081000 },
      { name: 'Dongguan', slug: 'dongguan', population: 10615000 },
      { name: 'Chengdu', slug: 'chengdu', population: 10152000 },
      { name: 'Foshan', slug: 'foshan', population: 9498000 },
      { name: 'Nanjing', slug: 'nanjing', population: 9423000 },
      { name: 'Shenyang', slug: 'shenyang', population: 9070000 },
      { name: 'Hangzhou', slug: 'hangzhou', population: 8700000 },
      { name: 'Xi\'an', slug: 'xian', population: 8467000 },
      { name: 'Harbin', slug: 'harbin', population: 7910000 },
      { name: 'Suzhou', slug: 'suzhou', population: 7071000 },
      { name: 'Qingdao', slug: 'qingdao', population: 7003000 },
      { name: 'Dalian', slug: 'dalian', population: 6991000 },
      { name: 'Zhengzhou', slug: 'zhengzhou', population: 6766000 },
      { name: 'Shantou', slug: 'shantou', population: 5502000 },
      { name: 'Jinan', slug: 'jinan', population: 5052000 },
      { name: 'Changchun', slug: 'changchun', population: 4781000 },
      { name: 'Kunming', slug: 'kunming', population: 4657000 },
      { name: 'Changsha', slug: 'changsha', population: 4073000 },
      { name: 'Taiyuan', slug: 'taiyuan', population: 3426000 },
      { name: 'Xiamen', slug: 'xiamen', population: 3531000 },
      { name: 'Hefei', slug: 'hefei', population: 3352000 },
      { name: 'Urumqi', slug: 'urumqi', population: 3112000 },
      { name: 'Fuzhou', slug: 'fuzhou', population: 2921000 },
      { name: 'Wuxi', slug: 'wuxi', population: 2749000 },
      { name: 'Zhongshan', slug: 'zhongshan', population: 2748000 },
      { name: 'Wenzhou', slug: 'wenzhou', population: 2718000 },
      { name: 'Nanning', slug: 'nanning', population: 2540000 },
      { name: 'Nanchang', slug: 'nanchang', population: 2357000 },
      { name: 'Ningbo', slug: 'ningbo', population: 2583000 },
      { name: 'Guiyang', slug: 'guiyang', population: 2520000 },
      { name: 'Lanzhou', slug: 'lanzhou', population: 2177000 },
      { name: 'Zhuhai', slug: 'zhuhai', population: 2457000 },
      { name: 'Haikou', slug: 'haikou', population: 2046000 },
      { name: 'Changzhou', slug: 'changzhou', population: 2042000 },
      { name: 'Shijiazhuang', slug: 'shijiazhuang', population: 2834000 },
      { name: 'Tangshan', slug: 'tangshan', population: 1577000 },
      { name: 'Baoding', slug: 'baoding', population: 1119000 },
      { name: 'Handan', slug: 'handan', population: 1056000 },
      { name: 'Xingtai', slug: 'xingtai', population: 611000 },
      { name: 'Zhangjiakou', slug: 'zhangjiakou', population: 613000 },
      { name: 'Chengde', slug: 'chengde', population: 521000 },
      { name: 'Cangzhou', slug: 'cangzhou', population: 712000 },
      { name: 'Langfang', slug: 'langfang', population: 527000 },
      { name: 'Hengshui', slug: 'hengshui', population: 456000 }
    ]
  },
  {
    code: 'JP',
    name: 'Japan',
    slug: 'japan',
    population: 126476461,
    topCities: [
      { name: 'Tokyo', slug: 'tokyo', population: 13929286 },
      { name: 'Yokohama', slug: 'yokohama', population: 3724844 },
      { name: 'Osaka', slug: 'osaka', population: 2691185 },
      { name: 'Nagoya', slug: 'nagoya', population: 2295638 },
      { name: 'Sapporo', slug: 'sapporo', population: 1952356 },
      { name: 'Fukuoka', slug: 'fukuoka', population: 1538681 },
      { name: 'Kobe', slug: 'kobe', population: 1537272 },
      { name: 'Kawasaki', slug: 'kawasaki', population: 1475213 },
      { name: 'Kyoto', slug: 'kyoto', population: 1474570 },
      { name: 'Saitama', slug: 'saitama', population: 1263979 },
      { name: 'Hiroshima', slug: 'hiroshima', population: 1194034 },
      { name: 'Sendai', slug: 'sendai', population: 1086377 },
      { name: 'Kitakyushu', slug: 'kitakyushu', population: 961286 },
      { name: 'Chiba', slug: 'chiba', population: 971882 },
      { name: 'Setagaya', slug: 'setagaya', population: 917486 },
      { name: 'Nerima', slug: 'nerima', population: 721908 },
      { name: 'Adachi', slug: 'adachi', population: 678087 },
      { name: 'Ota', slug: 'ota', population: 717082 },
      { name: 'Katsushika', slug: 'katsushika', population: 447140 },
      { name: 'Edogawa', slug: 'edogawa', population: 678967 },
      { name: 'Nakano', slug: 'nakano', population: 328215 },
      { name: 'Suginami', slug: 'suginami', population: 563124 },
      { name: 'Itabashi', slug: 'itabashi', population: 567441 },
      { name: 'Seijo', slug: 'seijo', population: 917486 },
      { name: 'Shibuya', slug: 'shibuya', population: 228701 },
      { name: 'Minato', slug: 'minato', population: 248071 },
      { name: 'Taito', slug: 'taito', population: 200486 },
      { name: 'Koto', slug: 'koto', population: 513710 },
      { name: 'Shinagawa', slug: 'shinagawa', population: 392492 },
      { name: 'Meguro', slug: 'meguro', population: 280283 },
      { name: 'Bunkyo', slug: 'bunkyo', population: 223389 },
      { name: 'Sumida', slug: 'sumida', population: 256363 },
      { name: 'Kita', slug: 'kita', population: 341076 },
      { name: 'Arakawa', slug: 'arakawa', population: 216615 },
      { name: 'Toshima', slug: 'toshima', population: 294673 },
      { name: 'Shinjuku', slug: 'shinjuku', population: 339211 },
      { name: 'Hachioji', slug: 'hachioji', population: 577344 },
      { name: 'Machida', slug: 'machida', population: 428851 },
      { name: 'Fujisawa', slug: 'fujisawa', population: 429881 },
      { name: 'Kashiwa', slug: 'kashiwa', population: 417092 },
      { name: 'Toyonaka', slug: 'toyonaka', population: 400973 },
      { name: 'Kanazawa', slug: 'kanazawa', population: 465699 },
      { name: 'Nagasaki', slug: 'nagasaki', population: 429508 },
      { name: 'Machida', slug: 'machida-duplicate', population: 428851 },
      { name: 'Gifu', slug: 'gifu', population: 413136 },
      { name: 'Himeji', slug: 'himeji', population: 536270 },
      { name: 'Matsuyama', slug: 'matsuyama', population: 514865 },
      { name: 'Kasugai', slug: 'kasugai', population: 306000 },
      { name: 'Kawaguchi', slug: 'kawaguchi', population: 594915 },
      { name: 'Iwaki', slug: 'iwaki', population: 349466 },
      { name: 'Kurume', slug: 'kurume', population: 308087 },
      { name: 'Akita', slug: 'akita', population: 315814 }
    ]
  },
  {
    code: 'KR',
    name: 'South Korea',
    slug: 'south-korea',
    population: 51269185,
    topCities: [
      { name: 'Seoul', slug: 'seoul', population: 9720846 },
      { name: 'Busan', slug: 'busan', population: 3448737 },
      { name: 'Incheon', slug: 'incheon', population: 2954642 },
      { name: 'Daegu', slug: 'daegu', population: 2466052 },
      { name: 'Daejeon', slug: 'daejeon', population: 1538394 },
      { name: 'Gwangju', slug: 'gwangju', population: 1469214 },
      { name: 'Suwon', slug: 'suwon', population: 1194313 },
      { name: 'Ulsan', slug: 'ulsan', population: 1166377 },
      { name: 'Changwon', slug: 'changwon', population: 1059241 },
      { name: 'Goyang', slug: 'goyang', population: 1073069 },
      { name: 'Yongin', slug: 'yongin', population: 1020262 },
      { name: 'Seongnam', slug: 'seongnam', population: 973931 },
      { name: 'Bucheon', slug: 'bucheon', population: 843794 },
      { name: 'Ansan', slug: 'ansan', population: 692652 },
      { name: 'Jeonju', slug: 'jeonju', population: 658172 },
      { name: 'Anyang', slug: 'anyang', population: 593085 },
      { name: 'Cheongju', slug: 'cheongju', population: 834000 },
      { name: 'Cheonan', slug: 'cheonan', population: 629062 },
      { name: 'Namyangju', slug: 'namyangju', population: 674902 },
      { name: 'Hwaseong', slug: 'hwaseong', population: 764486 },
      { name: 'Pohang', slug: 'pohang', population: 508899 },
      { name: 'Uijeongbu', slug: 'uijeongbu', population: 462809 },
      { name: 'Siheung', slug: 'siheung', population: 446062 },
      { name: 'Gimhae', slug: 'gimhae', population: 543814 },
      { name: 'Pyeongtaek', slug: 'pyeongtaek', population: 504775 },
      { name: 'Jinju', slug: 'jinju', population: 348687 },
      { name: 'Gunpo', slug: 'gunpo', population: 287576 },
      { name: 'Wonju', slug: 'wonju', population: 364860 },
      { name: 'Osan', slug: 'osan', population: 227648 },
      { name: 'Iksan', slug: 'iksan', population: 281759 },
      { name: 'Yangju', slug: 'yangju', population: 229901 },
      { name: 'Suncheon', slug: 'suncheon', population: 281946 },
      { name: 'Chuncheon', slug: 'chuncheon', population: 284016 },
      { name: 'Gangneung', slug: 'gangneung', population: 213658 },
      { name: 'Jeju', slug: 'jeju', population: 486006 },
      { name: 'Mokpo', slug: 'mokpo', population: 233821 },
      { name: 'Yeosu', slug: 'yeosu', population: 282946 },
      { name: 'Tongyeong', slug: 'tongyeong', population: 134227 },
      { name: 'Sacheon', slug: 'sacheon', population: 112494 },
      { name: 'Gimcheon', slug: 'gimcheon', population: 139776 },
      { name: 'Andong', slug: 'andong', population: 167821 },
      { name: 'Gumi', slug: 'gumi', population: 420016 },
      { name: 'Yeongju', slug: 'yeongju', population: 109305 },
      { name: 'Sangju', slug: 'sangju', population: 101940 },
      { name: 'Mungyeong', slug: 'mungyeong', population: 74869 },
      { name: 'Gyeongsan', slug: 'gyeongsan', population: 276381 },
      { name: 'Gyeongju', slug: 'gyeongju', population: 256601 },
      { name: 'Gimje', slug: 'gimje', population: 86603 },
      { name: 'Jeongeup', slug: 'jeongeup', population: 115469 }
    ]
  },
  {
    code: 'MN',
    name: 'Mongolia',
    slug: 'mongolia',
    population: 3278290,
    topCities: [
      { name: 'Ulaanbaatar', slug: 'ulaanbaatar', population: 1396288 },
      { name: 'Erdenet', slug: 'erdenet', population: 79647 },
      { name: 'Darkhan', slug: 'darkhan', population: 74300 },
      { name: 'Choibalsan', slug: 'choibalsan', population: 38537 },
      { name: 'Murun', slug: 'murun', population: 35789 },
      { name: 'Ulaangom', slug: 'ulaangom', population: 29123 },
      { name: 'Hovd', slug: 'hovd', population: 30500 },
      { name: 'Olgii', slug: 'olgii', population: 28400 },
      { name: 'Tsetserleg', slug: 'tsetserleg', population: 16553 },
      { name: 'Sainshand', slug: 'sainshand', population: 25637 },
      { name: 'Zamyn-Uud', slug: 'zamyn-uud', population: 18314 },
      { name: 'Bayankhongor', slug: 'bayankhongor', population: 26252 },
      { name: 'Mandalgovi', slug: 'mandalgovi', population: 15430 },
      { name: 'Dalanzadgad', slug: 'dalanzadgad', population: 19396 },
      { name: 'Altai', slug: 'altai-mn', population: 15800 },
      { name: 'Uliastai', slug: 'uliastai', population: 16240 },
      { name: 'Arvayheer', slug: 'arvayheer', population: 25622 },
      { name: 'Bulgan', slug: 'bulgan', population: 12600 },
      { name: 'Sukhbaatar', slug: 'sukhbaatar-mn', population: 20000 },
      { name: 'Undurkhaan', slug: 'undurkhaan', population: 15359 },
      { name: 'Choir', slug: 'choir', population: 9890 },
      { name: 'Baruun-Urt', slug: 'baruun-urt', population: 17500 },
      { name: 'Altanbulag', slug: 'altanbulag', population: 8500 },
      { name: 'Bayanhongor', slug: 'bayanhongor', population: 26252 },
      { name: 'Khovd', slug: 'khovd', population: 30500 },
      { name: 'Tes', slug: 'tes', population: 2500 },
      { name: 'Tsagaannuur', slug: 'tsagaannuur', population: 2800 },
      { name: 'Tarialan', slug: 'tarialan', population: 3200 },
      { name: 'Shine-Ider', slug: 'shine-ider', population: 2900 },
      { name: 'Khutag-Ondor', slug: 'khutag-ondor', population: 3500 },
      { name: 'Rashaant', slug: 'rashaant', population: 2600 },
      { name: 'Orkhon', slug: 'orkhon', population: 4500 },
      { name: 'Jargalant', slug: 'jargalant', population: 3800 },
      { name: 'Gurvanbulag', slug: 'gurvanbulag', population: 3200 },
      { name: 'Khyalganat', slug: 'khyalganat', population: 2800 },
      { name: 'Tarialan Sum', slug: 'tarialan-sum', population: 3200 },
      { name: 'Khuder', slug: 'khuder', population: 2500 },
      { name: 'Rashaan', slug: 'rashaan', population: 2600 },
      { name: 'Tsenkher', slug: 'tsenkher', population: 2900 },
      { name: 'Jinst', slug: 'jinst', population: 2700 },
      { name: 'Bayan-Ondor', slug: 'bayan-ondor', population: 3100 },
      { name: 'Tarialan Center', slug: 'tarialan-center', population: 3200 },
      { name: 'Khangal', slug: 'khangal', population: 2400 },
      { name: 'Mungun-Morit', slug: 'mungun-morit', population: 2800 },
      { name: 'Khatgal', slug: 'khatgal', population: 3500 },
      { name: 'Renchinlkhumbe', slug: 'renchinlkhumbe', population: 2600 },
      { name: 'Tsagaan-Uul', slug: 'tsagaan-uul', population: 2900 },
      { name: 'Alag-Erdene', slug: 'alag-erdene', population: 2700 },
      { name: 'Tugrug', slug: 'tugrug', population: 2500 },
      { name: 'Bayan-Uul', slug: 'bayan-uul', population: 2800 },
      { name: 'Ikh-Uul', slug: 'ikh-uul', population: 2600 },
      { name: 'Tosontsengel', slug: 'tosontsengel', population: 3200 },
      { name: 'Zuunbayan-Ulaan', slug: 'zuunbayan-ulaan', population: 2400 },
      { name: 'Ulaan-Uul', slug: 'ulaan-uul', population: 2700 },
      { name: 'Buyant-Ukhaa', slug: 'buyant-ukhaa', population: 2500 },
      { name: 'Erdenebulgan', slug: 'erdenebulgan', population: 2800 },
      { name: 'Khutag-Undur', slug: 'khutag-undur', population: 2600 },
      { name: 'Telmen', slug: 'telmen', population: 2900 },
      { name: 'Zuun-Khandgait', slug: 'zuun-khandgait', population: 2300 },
      { name: 'Chandmani-Ondor', slug: 'chandmani-ondor', population: 2700 },
      { name: 'Bugat', slug: 'bugat', population: 2500 },
      { name: 'Jargalant Sum', slug: 'jargalant-sum', population: 3800 },
      { name: 'Dayan', slug: 'dayan', population: 2600 },
      { name: 'Tsogttsetsii', slug: 'tsogttsetsii', population: 2400 },
      { name: 'Khujirt', slug: 'khujirt', population: 2800 },
      { name: 'Bat-Olzii', slug: 'bat-olzii', population: 2500 },
      { name: 'Bayan-Ovoo', slug: 'bayan-ovoo', population: 2700 },
      { name: 'Gurvansaikhan', slug: 'gurvansaikhan', population: 2600 },
      { name: 'Mandal-Ovoo', slug: 'mandal-ovoo', population: 2400 },
      { name: 'Biger', slug: 'biger', population: 2300 },
      { name: 'Shine-Jinst', slug: 'shine-jinst', population: 2500 },
      { name: 'Naranbulag', slug: 'naranbulag', population: 2800 },
      { name: 'Lun', slug: 'lun', population: 2600 },
      { name: 'Erdenesant', slug: 'erdenesant', population: 2700 },
      { name: 'Khuld', slug: 'khuld', population: 2400 },
      { name: 'Khashaat', slug: 'khashaat', population: 2500 },
      { name: 'Bayangol', slug: 'bayangol', population: 2800 },
      { name: 'Batshireet', slug: 'batshireet', population: 2600 },
      { name: 'Tserendorj', slug: 'tserendorj', population: 2300 },
      { name: 'Dadal', slug: 'dadal', population: 2700 },
      { name: 'Bayan-Adraga', slug: 'bayan-adraga', population: 2500 },
      { name: 'Matad', slug: 'matad', population: 2400 },
      { name: 'Khalkhgol', slug: 'khalkhgol', population: 2800 },
      { name: 'Dashbalbar', slug: 'dashbalbar', population: 2600 },
      { name: 'Bayan-Tumen', slug: 'bayan-tumen', population: 2900 },
      { name: 'Tsagaan-Ovoo', slug: 'tsagaan-ovoo', population: 2500 },
      { name: 'Norovlin', slug: 'norovlin', population: 2700 },
      { name: 'Bor-Undur', slug: 'bor-undur', population: 2400 },
      { name: 'Sergelen', slug: 'sergelen', population: 2800 },
      { name: 'Jargaltkhaan', slug: 'jargaltkhaan', population: 2300 },
      { name: 'Mungunmorit', slug: 'mungunmorit', population: 2600 },
      { name: 'Erdene', slug: 'erdene', population: 2500 },
      { name: 'Batsumber', slug: 'batsumber', population: 2700 },
      { name: 'Argalant', slug: 'argalant', population: 2400 },
      { name: 'Zuunmod', slug: 'zuunmod', population: 17630 },
      { name: 'Lkhagvasuren', slug: 'lkhagvasuren', population: 2500 },
      { name: 'Bayandelger', slug: 'bayandelger', population: 2800 },
      { name: 'Bornuur', slug: 'bornuur', population: 2600 },
      { name: 'Mandal', slug: 'mandal', population: 2300 },
      { name: 'Erdenedalai', slug: 'erdenedalai', population: 2700 },
      { name: 'Saikhan', slug: 'saikhan', population: 2500 },
      { name: 'Bayantsagaan', slug: 'bayantsagaan', population: 2400 },
      { name: 'Altanshiree', slug: 'altanshiree', population: 2800 },
      { name: 'Khentii', slug: 'khentii', population: 2600 },
      { name: 'Delgerkhaan', slug: 'delgerkhaan', population: 2300 }
    ]
  }
];
